import {priceHelper} from '@helpers/config-master.mjs';

export const SendViewItemHitToAnalyticsAPI = (product) => {
  const doPostToAPI = (hitEvent) => {
    return fetch('/api/analytics/events/view-item', {
      method: "POST",
      body: JSON.stringify(hitEvent),
      headers: {"Content-Type": "application/json"},
    })
  }

  // console.log({SendViewItemHitToAnalyticsAPI: product});
  const finalProductPrice = Number(priceHelper.getFinalPrice(product).toFixed(2));
  const sku = product?.sku;
  const category = product?.category;
  const productName = product?.name;

  const hitEvent = {
    content_type: 'product',
    content_ids: [sku],
    content_name: productName,
    content_category: category,
    value: Number(finalProductPrice),
    currency: 'USD'
  }
  // console.log("[SendViewItemHitToAnalyticsAPI] hitEvent:", hitEvent);
  doPostToAPI(hitEvent).then().catch(console.error)
  return;
}
